import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment as ENV } from '../../environments/environment';
import { IFinalPaperDocument, IFinalPaperDocumentFile } from '../models/FinalPaperDocument';

/**
 * Final paper document service
 */
@Injectable({ providedIn: "root" })
export class FinalPaperDocumentService {
    constructor(private http: HttpClient) { }

    public get apiUrl(): string { return `${ENV.apiUrl}/finalPaperDocuments` }

    getProtocols(upn?: string): Observable<IFinalPaperDocument[]> {
        const url = `${this.apiUrl}/protocols`;
        const params = upn ? { upn } : {};
        return this.http.get<IFinalPaperDocument[]>(url, { params });
    }

    getOrders(upn?: string): Observable<IFinalPaperDocument[]> {
        const url = `${this.apiUrl}/orders`;
        const params = upn ? { upn } : {};
        return this.http.get<IFinalPaperDocument[]>(url, { params });
    }

    getFiles(id: number, upn?: string): Observable<IFinalPaperDocumentFile[]> {
        const url = `${this.apiUrl}/${id}/files`;
        const params = upn ? { upn } : {};
        return this.http.get<IFinalPaperDocumentFile[]>(url, { params });
    }

    getFileDownloadUrl(documentId: number, fileId: number, upn?: string): string {
        return `${this.apiUrl}/${documentId}/files/${fileId}/download` + (upn ? `?upn=${upn}` : '');
    }
}
